import { Briefcase, Rocket } from 'lucide-react'

/** The left-hand branding of the sign-in split layout. The copy follows the role; before one is picked it reads as a founder's. */
export function OnboardingBrandPanel({ audience }: { audience: 'founder' | 'investor' | null }) {
  return (
    <div className="hidden w-1/2 flex-col justify-between p-12 lg:flex">
      <div>
        <img src="/seedforge-logo.svg" alt="SeedForge" className="h-8" />
      </div>
      <div className="max-w-md">
        {audience === 'investor' ? (
          <>
            <Briefcase className="mb-4 size-10 text-[#f97316]" />
            <h2 className="text-2xl font-semibold leading-snug text-foreground">
              Discover pre-vetted startups matched to your thesis
            </h2>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">
              Upload your investment thesis and we'll match you with relevant startups, saving hours
              of deal sourcing.
            </p>
          </>
        ) : (
          <>
            <Rocket className="mb-4 size-10 text-[#f97316]" />
            <h2 className="text-2xl font-semibold leading-snug text-foreground">
              Prove your startup. Raise faster.
            </h2>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">
              Upload your deck and take one 30-minute session. SeedForge turns it into a profile
              investors explore before your first call, then puts it in front of the funds that
              match you.
            </p>
          </>
        )}
      </div>
      <p className="text-xs text-muted-foreground/80">Your data stays private. Always.</p>
    </div>
  )
}
